import Icon from '../components/Icon.vue'

Icon.register({"user-circle-o":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348q0 181-70.5 347t-190.5 286-286 191.5-349 71.5-349-71-285.5-191.5-190.5-286-71-347.5 71-348 191-286 286-191 348-71zM1515 1351q149-205 149-455 0-156-61-298t-164-245-245-164-298-61-298 61-245 164-164 245-61 298q0 250 149 455 66-327 306-327 131 128 313 128t313-128q240 0 306 327zM1280 704q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-circle-o.js
// module id = 1847
// module chunks = 0